import { StreamChat } from 'stream-chat'

import { env } from 'src/config/env'

export const SCROLL_VELOCITY_THRESHOLD = 1000
export const client = StreamChat.getInstance(env.STREAM_API_KEY)
